import { Alert, Button, Form } from "react-bootstrap";
import { Modal, MuniSpinner2 } from "../../../components";
import { useGeneralAppStore } from "../../../store/generalAppStore";
import useActas from "../../../api/actas";
import { useForm } from "react-hook-form";
import { useActaDetalleStore } from "../../../store/actaDetalleStore";
import SendIcon from '@mui/icons-material/Send';

const ModalEditarActa = ({ modals, handlerModal, setRefetch }) => {


    //? ESTADOS GLOABLES
    const { loads } = useGeneralAppStore();
    const { acta, actaDetalle } = useActaDetalleStore();
    //TODO API
    const { completarDatosDomicilio, marcarActaComoAprobadoParaImprimir } = useActas();

    const { register, handleSubmit, watch } = useForm({
        defaultValues: {
            documento_titular: acta?.documento_titular,
            direccion_titular: acta?.direccion_titular,
            provincia: acta?.provincia,
            localidad: acta?.localidad,
            codigo_postal: acta?.codigo_postal,
            razonSocial: acta?.razonSocial,
            tipo: acta?.tipo
        }
    })


    const onSubmit = (data) => {
        // console.log(data)
        // completarDatosDomicilio({ ...data, numero_infraccion: acta?.numero_infraccion, id: acta?.id, is_edit: true }, setRefetch);
        marcarActaComoAprobadoParaImprimir({ ...data, numero_infraccion: acta?.numero_infraccion, id_acta: acta?.id, is_edit: true }, setRefetch);

    }


    return (
        <>
            <Modal
                show={modals.includes('editar_acta')}
                size={"lg"}
                onHide={() => handlerModal({ modal: false, modalName: "editar_acta" })}
                title={() => "Completar acta"}
            >
                <div className="position-relative">
                    {
                        loads.includes('completar_datos') || loads.includes('editar_acta') || loads.includes('aprobada_imprimir') &&
                        <div className="position-absolute h-100 w-100 d-flex justify-content-center align-items-center" style={{ backgroundColor: "rgba(255,255,255,0.7)" }}>
                            <MuniSpinner2 />
                        </div>
                    }
                    <Form onSubmit={handleSubmit(onSubmit)} className="  row px-2">

                        <Alert variant="info" className="col-12" style={{ fontSize: "14px" }}>
                            <p className="m-0">Al <span className="fw-bold ">COMPLETAR</span> el acta, pasara al estado <span className="fw-bold">APROBADO</span> automaticamente. Verifique los datos antes de completar el acta</p>

                        </Alert>
                        <Form.Group className="col-6 mb-3">
                            <Form.Label className="m-0 fs-6">Provincia</Form.Label>
                            <Form.Control placeholder="Provincia..."  {...register('provincia')} />
                        </Form.Group>

                        <Form.Group className="col-6 mb-3">
                            <Form.Label className="m-0">Localidad</Form.Label>
                            <Form.Control placeholder="Localidad..." {...register('localidad')} />
                        </Form.Group>

                        <Form.Group className="col-6 mb-3">
                            <Form.Label className="m-0">Código postal</Form.Label>
                            <Form.Control placeholder="Código postal..." type="number" {...register('codigo_postal')} />
                        </Form.Group>
                        <Form.Group className="col-6 mb-3">
                            <Form.Label className="m-0">Documento</Form.Label>
                            <Form.Control placeholder="Documento del titular..." {...register('documento_titular')} />
                        </Form.Group>

                        <Form.Group className="col-12 mb-3">
                            <Form.Label className="m-0">Dirección</Form.Label>
                            <Form.Control placeholder="Dirección del titular..." {...register('direccion_titular')} />
                        </Form.Group>

                        <Form.Group className="col-6 mb-3">
                            <Form.Label className="m-0">Razón Social</Form.Label>
                            <Form.Control placeholder="Dirección del titular..." {...register('razonSocial')} />
                        </Form.Group>
                        {/* //! Ver para agregar tipo infraccion en completar acta */}
                        <Form.Group className="col-6 mb-3">
                            <Form.Label className="m-0">Tipo infracción</Form.Label>
                            <Form.Control as={'select'} placeholder="Tipo infracción..." {...register('tipo')} >
                                <option value="Semaforo Luz Roja">Semaforo Luz Roja</option>
                                <option value="Semaforo Senda">Semaforo Senda</option>
                                <option value="Semaforo Giro">Semaforo Giro</option>
                            </Form.Control>
                        </Form.Group>

                        {/* <Form.Group className="col-6 mb-3">
                            <Form.Label className="m-0">Tipo infracción</Form.Label>
                            <Form.Control as={"select"} placeholder="Dirección del titular..." {...register('tipo')} >
                                <option value={"Semaforo Giro"}>Semaforo Giro</option>
                                <option value={"Semaforo Luz Roja"}>Semaforo Luz Roja</option>
                                <option value={"Semaforo Senda"}>Semaforo Senda</option>
                            </Form.Control>
                        </Form.Group> */}





                        {
                            (watch('direccion_titular') == "" || watch('documento_titular') == "" || watch('provincia') == "" || watch('localidad') == "" || watch('codigo_postal') == "") ?
                                <div className="d-flex justify-content-center" style={{ height: "20px" }}>
                                    <span className="text-danger fw-medium">Debe completar todo los campos</span>
                                </div>
                                :
                                <div className="d-flex justify-content-center" style={{ height: "20px" }} />

                        }

                        <hr />
                        <div className="d-flex justify-content-end">
                            <Button className={'d-flex gap-2'} disabled={(watch('direccion_titular') == "" || watch('documento_titular') == "" || watch('provincia') == "" || watch('localidad') == "" || watch('codigo_postal') == "")} type="submit">Enviar <SendIcon /></Button>
                        </div>
                    </Form>
                </div>

            </Modal>
        </>
    );
}
export default ModalEditarActa;